
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction, createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import { editLocation } from 'state/locations/actions';


const openModal = createOpenModalAction('EditLocationModal');
const closeModal = createCloseModalAction('EditLocationModal');

export const startEditingLocation = (locationId, edits) => dispatch => {
    dispatch({
        type: actions.START_EDITING_LOCATION,
        payload: { locationId }
    })
    dispatch(editLocation(locationId, edits));
    dispatch(openModal());
}


export const stopEditingLocation = () => dispatch => {
    dispatch({
        type: actions.STOP_EDITING_LOCATION
    })
    dispatch(closeModal());
}